'use strict'

import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import 'primevue/resources/themes/saga-blue/theme.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
import 'primevue/resources/primevue.min.css'

import PrimeVue from 'primevue/config'
import Tooltip from 'primevue/tooltip'

import Notifications from '@kyvg/vue3-notification'
import router from '@/router'

import App from './App.vue'
const app = createApp(App)

const piniaStore = createPinia()
piniaStore.use(piniaPluginPersistedstate)

app.use(piniaStore)
app.use(router)
app.use(Notifications)
app.use(PrimeVue)
app.directive('tooltip', Tooltip);

app.mount('#app')
